import { useFormikContext } from 'formik';

import ConfirmationModal from '../basics/ConfirmationModal';

const NoteSaveConfirmation = ({ isOpen, onCancel, onConfirm }) => {
  const { values } = useFormikContext();
  return (
    <ConfirmationModal
      isOpen={isOpen}
      title="Save new changes?"
      actionDescriptionSentence="Your note has unsaved changes."
      actionQuestion="Would you like to save your changes before closing?"
      actionName="Save"
      cancelName="Discard changes"
      onCancel={onCancel}
      onConfirm={() => onConfirm(values)}
    />
  );
};

export default NoteSaveConfirmation;
